import type React from "react";

const Features: React.FC = () => {
	const features = [
		{
			id: "output",
			title: "アウトプットできる環境",
			description:
				"自分の学んだことをすぐに実践し、アウトプットすることができます。",
			icon: "💡",
		},
		{
			id: "beginner",
			title: "初心者から上級者まで歓迎",
			description: "初心者から上級者まで、どんなレベルの方でも歓迎します。",
			icon: "👨‍🎓",
		},
		{
			id: "age",
			title: "年齢制限なし",
			description: "学生も社会人も意欲がある方はどなたでも参加できます。",
			icon: "🌍",
		},
		{
			id: "online",
			title: "オンラインからも参加可能",
			description: "オンラインでも参加できるので、場所を問わず参加できます。",
			icon: "💻",
		},
		{
			id: "mentor",
			title: "メンター常駐",
			description: "困ったときにはメンターが学習の計画を一緒に考えます。",
			icon: "👨‍🏫",
		},
		{
			id: "free",
			title: "参加費無料",
			description: "参加費は無料なので、気軽に参加できます。",
			icon: "💰",
		},
	];

	return (
		<section className="py-16 md:py-24 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">特徴</h2>
					<p className="text-lg text-gray-600">学習ギルドが提供する6つの特徴</p>
				</div>

				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
					{features.map((feature) => (
						<div
							key={feature.id}
							className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
						>
							<div className="text-4xl mb-4">{feature.icon}</div>
							<h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
							<p className="text-gray-600">{feature.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Features;
